import { classNames } from "@/react/helpers/twMergeWithCN";
import type { Step } from "../types";
import { CompletedStep } from "./steps/CompletedStep";
import { FocusedStep } from "./steps/FocusedStep";
import { IncompleteStep } from "./steps/IncompleteStep";

interface SectionStepProps {
  step: Step;
}

export const SectionStep = ({ step }: SectionStepProps) => {
  const { complete: isComplete, focus: isFocused } = step;

  const getStepComponent = () => {
    if (isFocused) return <FocusedStep step={step} isVisible />;
    if (isComplete) return <CompletedStep step={step} isVisible />;
    return <IncompleteStep step={step} isVisible />;
  };

  return (
    <div
      className={classNames(
        "duration-200 ease-[cubic-bezier(0.22,0.61,0.36,1)] motion-safe:transition-colors",
        {
          "bg-secondary rounded-xl": isFocused,
          "bg-transparent": !isFocused,
          "hover:bg-secondary/50": !isComplete && !isFocused,
        },
      )}
    >
      {getStepComponent()}
    </div>
  );
};
